import { colors, IconVeryHappyLarge, spacing } from "@izettle/otto"
import { Button } from "@izettle/react"
import { useLocalization } from "@izettle/tenko-react"

import { Flex, Title1, RegularText, Logo, SvgIcon } from "@/core/components/shared"

type OptOutComponentProps = {
  orgLogoUrl?: string
  orgName: string
  isOptingOutFethcing: boolean
  handleOptOutClick: () => void
}

export const OptOutWelcomeComponent = ({
  orgLogoUrl,
  orgName,
  isOptingOutFethcing,
  handleOptOutClick,
}: OptOutComponentProps) => {
  const { text } = useLocalization()

  return (
    <>
      <Flex vCentered style={{ marginBottom: spacing.large }}>
        {orgLogoUrl ? (
          <Logo src={orgLogoUrl} />
        ) : (
          <SvgIcon html={IconVeryHappyLarge.svg} />
        )}
      </Flex>
      <Title1>{text("SIGNUP_OPTOUT_WELCOME_TITLE", [orgName])}</Title1>
      <RegularText color={colors.text.secondary}>
        {text("SIGNUP_OPTOUT_WECLOME_DESC", [orgName])}
      </RegularText>

      <Button
        onClick={handleOptOutClick}
        disabled={isOptingOutFethcing}
        loading={isOptingOutFethcing}
        size="large"
      >
        {"Remove"}
      </Button>
    </>
  )
}
